export const ByFilter = (key, value) => item => item[key] === value;
export const EqualFilter = value => item => item === value;



// WEBPACK FOOTER //
// ../~/pwet/src/filters.js